export default function ServicesHeader() {
  return (
    <section className="bg-[#F8FAFC] pt-32 pb-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-5">
          Our Services
        </span>
        <h1 className="text-5xl lg:text-6xl font-extrabold text-[#0F172A] mb-6 leading-tight">
          Automation That Runs{' '}
          <span className="text-blue-600">Your Operations</span>
        </h1>
        <p className="text-slate-500 text-xl leading-relaxed max-w-2xl mx-auto">
          From first contact to final job—handled automatically.
        </p>
      </div>
    </section>
  );
}
